module.exports = __webpack_public_path__ + "static/media/sushi2.8525ad03.jpg";